/**
 * @generated SignedSource<<0aa855fb602df543472741f06c9b6f72>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OccurrencesContentTemplate_salesAssociate$data = {
  readonly name: string | null;
  readonly avatar: {
    readonly url: string;
  } | null;
  readonly " $fragmentType": "OccurrencesContentTemplate_salesAssociate";
};
export type OccurrencesContentTemplate_salesAssociate$key = {
  readonly " $data"?: OccurrencesContentTemplate_salesAssociate$data;
  readonly " $fragmentSpreads": FragmentRefs<"OccurrencesContentTemplate_salesAssociate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OccurrencesContentTemplate_salesAssociate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Avatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SalesAssociate",
  "abstractKey": null
};

(node as any).hash = "16b1157db5b601566f7980c06f56cbfd";

export default node;
